import { Controller } from "stimulus";

export default class extends Controller {
  static values = { videoId: String };
  static targets = ["placeholder", "playerContainer"];

  connect() {
    const autoplay = new URLSearchParams(window.location.search).get("autoplay");

    if (autoplay === "1") {
      this.loadPlayer(true);
    } else {
      this.placeholderTarget.classList.remove("d-none");
      this.placeholderTarget.addEventListener("click", () => this.handlePlaceholderClick());
    }
  }

  disconnect() {
    delete window.onYouTubeIframeAPIReady;
  }

  handlePlaceholderClick() {
    this.loadPlayer(true);
    const url = new URL(window.location.href);
    url.searchParams.set("autoplay", "1");
    history.pushState({}, "", url.toString());
  }

  loadPlayer(autoplay = false) {
    if (!this.videoIdValue) return;

    const iframe = document.createElement("iframe");
    iframe.setAttribute("class", "ytPlayer");
    iframe.setAttribute("width", "100%");
    iframe.setAttribute("height", "100%");
    iframe.setAttribute("allow", "accelerometer; autoplay; encrypted-media; gyroscope");
    iframe.src = `https://www.youtube.com/embed/${this.videoIdValue}?autoplay=${autoplay ? "1" : "0"}&enablejsapi=1&controls=0&rel=0&iv_load_policy=3`;

    this.playerContainerTarget.innerHTML = "";
    this.playerContainerTarget.appendChild(iframe);
    this.playerContainerTarget.classList.remove("d-none");
    this.placeholderTarget.classList.add("d-none");

    const container = document.getElementById("videoContainer");
    if (container) container.classList.add("playing");


    window.YT && window.YT.Player ? this.initPlayer() : this.loadYouTubeAPI();
  }

  loadYouTubeAPI() {
    if (document.querySelector('script[src*="youtube.com/iframe_api"]')) {
      const originalCallback = window.onYouTubeIframeAPIReady || (() => {});
      window.onYouTubeIframeAPIReady = () => {
        originalCallback();
        this.initPlayer();
      };
      return;
    }

    const tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    window.onYouTubeIframeAPIReady = () => this.initPlayer();
    document.body.appendChild(tag);
  }

  initPlayer() {
    new YT.Player("ytPlayer", {
      events: {
        onStateChange: (event) => {
          const container = document.getElementById("videoContainer");
          if (container) {
            container.classList.toggle("playing", event.data === YT.PlayerState.PLAYING);
          }
        }
      }
    });
  }
}